import React from 'react';
import Translate from 'react-translate-component';

import { strToDate, strToTime, strToDateMonth } from 'mappers/commonMapper';
import { getDateTimeRange } from 'helpers/fieldsHelpers';

export const DateField = ({ date }) => (
    <span>
        {strToDate(date)}
    </span>
);

export const TimeField = ({ time }) => (
    <span>
        {strToTime(time)}
    </span>
);

export const DateTimeField = ({ date, time }) => (
    <span>
        <DateField date={date} /> <TimeField time={time} />
    </span>
);

export const TimeRangeField = ({ time = {}, hideEmpty }) => (
    <span>
        {getDateTimeRange(
            {
                from: strToTime(time.from),
                to: strToTime(time.to)
            },
            hideEmpty ? '' : <Translate content="calendar.whole_day" />
        )}
    </span>
);

export const DateRangeField = ({ date = {} }) => (
    <span>
        {getDateTimeRange({
            from: strToDate(date.from),
            to: strToDate(date.to)
        })}
    </span>
);

export const MonthYearField = ({ date }) => {
    return strToDateMonth(date);
};
